export default "/images/forsia.webp?678ed9646175f39f9109c8470ef3f73b";